// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-10829a52],.title[data-v-10829a52]{margin-bottom:10px}.box[data-v-10829a52]{display:grid;grid-template-columns:auto 75px;align-items:center}.box .value[data-v-10829a52]{flex:1}.box .value INPUT[data-v-10829a52]{height:61px}.remove[data-v-10829a52]{text-align:right}.footer .protip[data-v-10829a52]{float:right;padding:5px 0}", ""]);
// Exports
module.exports = exports;
